import { motion } from "framer-motion";
import { Box } from "lucide-react";

export const HeroVisual = ({ rx, ry }) => (
  <motion.div
    style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }}
    initial={{ opacity: 0, y: 40 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1.1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
    className="relative pb-6"
  >
    <motion.div
      initial={{ clipPath: "inset(14% 14% 14% 14% round 28px)" }}
      animate={{ clipPath: "inset(0% 0% 0% 0% round 28px)" }}
      transition={{ duration: 1.4, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
      className="relative rounded-[28px] overflow-hidden shadow-[0_40px_80px_-30px_rgba(19,41,107,0.55)] aspect-[3/2] bg-white"
    >
      <motion.img
        initial={{ scale: 1.25 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.8, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
        src="/brand/hero-marketgetr.jpg"
        alt="Marketgetr package at a doorstep with delivery van"
        className="h-full w-full object-cover"
        data-testid="hero-image"
      />
    </motion.div>

    <div style={{ transform: "translateZ(90px)" }} className="absolute right-2 sm:-right-6 -bottom-8 h-24 w-24 sm:h-28 sm:w-28">
      <svg viewBox="0 0 100 100" className="spin-slow h-full w-full drop-shadow-xl">
        <defs><path id="c" d="M50,50 m-38,0 a38,38 0 1,1 76,0 a38,38 0 1,1 -76,0" /></defs>
        <circle cx="50" cy="50" r="49" fill="#2F7FF0" />
        <text fill="#fff" fontSize="10.5" fontFamily="JetBrains Mono Variable, monospace" letterSpacing="2.4"><textPath href="#c">COMING SOON • COMING SOON • </textPath></text>
      </svg>
      <span className="absolute inset-0 flex items-center justify-center"><Box className="h-8 w-8 text-white" /></span>
    </div>
  </motion.div>
);
